import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CommonButton from "../Buttons/CommonButton";
import Createdevicemetermodal from "../../Modals/Device/CreateDeviceMeterModal";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import {
  DeleteDeviceMeter,
  DropdownService,
  ListDeviceMeter,
  MakeDropdown,
  ModelDropdown,
} from "../../Services/ApiServices";

import {
  CatchMessage,
  CheckUserType,
  JSONtoformdata,
  tokenisValid,
} from "../../Shared/Methods";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import Commonpagination from "../Tables/CommonPagination";
import { useLocation } from "react-router-dom";
import SubscriptionModal from "../../Modals/SubscriptionModal";
import ReplaceMeter from "../../Modals/Device/ReplaceMeterMOdal";
import ResetValueModal from "../../Modals/Device/ResetValueModal";
import DeleteConfirmation from "../../Modals/DeleteConfirmation";
import DeviceMeterTablePage from "./DeviceMeterTablePage";
import DeviceUserDetails from "./DeviceUserDetails";

function Devicemeter() {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [listMeterData, setListMeterData] = useState<any>("");
  const [showmodal, setShowModal] = useState({
    isView: false,
    action: "",
    item: "",
  });

  const [replacemetermodal, setShowreplacemeterModal] = useState({
    isView: false,
    action: "",
    item: "",
  });
  const [resetvaluemodal, setShowresetvalueModal] = useState({
    isView: false,
    action: "",
    item: "",
  });

  const { items, total_count, total_page, page, size } = listMeterData || {};

  const [DropDowns, setDropDowns] = useState({
    ParameterType: [],
    Meter: [],
    Make: [],
    Model: [],
    Baudrate: [],
    Parity: [],
    Databits: [],
    Stopbits: [],
    isParameterTypeLoading: true,
    isMeterLoading: true,
    isMakeLoading: true,
    isModalLoading: true,
    isBaudrateLoading: true,
    isParityLoading: true,
    isDatabitsLoading: true,
    isStopbitsLoading: true,
  });
  const [showConfirmModal, setShowConfirmModal] = useState<any>({
    isView: false,
    item: "",
  });
  const [pageSize, setpageSize] = useState(10);
  const [pageind, setPageInd] = useState(0);
  const [subscribe, setsubscribe] = useState({ isView: false, item: "" });

  useEffect(() => {
    if (LoginData !== null) {
      handleListMeter();
    }
  }, [LoginData]);

  // const handleListMeter = (page = 1, size = 10) => {
  //   dispatch(handleloading(true));

  //   const finalObj = {
  //     token: LoginData?.token,
  //   };

  //   ListDeviceMeter(JSONtoformdata(finalObj), page, size)
  //     .then((res) => {
  //       setListMeterData(res?.data?.data);
  //     })
  //     .catch((err) => CatchMessage(err))
  //     .finally(() => dispatch(handleloading(false)));
  // };

  const handleListMeter = (page = 1, size = 10) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      device_id: state?.item?.deviceId,
    };

    // const WithValues = !isreset
    //   ? Object.assign(finalObj, filterData ? filterData : Values)
    //   : finalObj;

    ListDeviceMeter(JSONtoformdata(finalObj), page, size)
      .then(async (res) => {
        if (res.data.status === 1) {
          setListMeterData(res?.data?.data);

          setPageInd(page > 1 ? page - 1 : 0);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getParameterTypeDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "parameterTypeDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isParameterTypeLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              ParameterType: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isParameterTypeLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getMeterDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "meterDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isMeterLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Meter: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isMeterLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getMakeDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    MakeDropdown(JSONtoformdata(finalObj))
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isMakeLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Make: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isMakeLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getModelDropDown = (brandid: "") => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      brand_id: brandid,
    };
    ModelDropdown(JSONtoformdata(finalObj))
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isModalLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Model: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isModalLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getDataBitsDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "databitsDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isDatabitsLoading: false,
          };
        });

        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Databits: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isDatabitsLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getStopBitsDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "stopbitsDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isStopbitsLoading: false,
          };
        });

        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Stopbits: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isStopbitsLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getParityDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "parityDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isParityLoading: false,
          };
        });

        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Parity: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isParityLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getBaudrateDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "baudrateDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isBaudrateLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Baudrate: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isBaudrateLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const DeleteDevice = (id: number) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      meter_id: id,
    };
    DeleteDeviceMeter(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          toast.success(res.data.msg);
          setPageInd(
            listMeterData?.items?.length === 1 && listMeterData?.page !== 1
              ? pageind - 1
              : pageind
          );
          handleListMeter(
            listMeterData?.items?.length === 1 && listMeterData?.page !== 1
              ? listMeterData?.page - 1
              : listMeterData?.page,
            pageSize
          );
          handleCancel();
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => dispatch(handleloading(false)));
  };

  const handleCancel = () => {
    setShowConfirmModal({ isView: false, item: "" });
    setShowModal({
      isView: false,
      item: "",
      action: "",
    });
    setsubscribe({ isView: false, item: "" });
    setDropDowns((pre) => {
      return {
        ...pre,
        isParameterTypeLoading: false,
        isMeterLoading: false,
        isMakeLoading: false,
        isModalLoading: false,
        isBaudrateLoading: false,
        isParityLoading: false,
        isDatabitsLoading: false,
      };
    });
  };

  const Changesize = (current: number, size: number) => {
    // setPageInd(0); //change into 0 from 1
    setpageSize(size);
    handleListMeter(1, size);
  };

  return (
    <>
      {subscribe?.isView ? (
        <SubscriptionModal
          onCancel={handleCancel}
          item={subscribe?.item}
          closable={!subscribe?.isView}
          open={subscribe?.isView}
        />
      ) : null}

      {showConfirmModal?.isView ? (
        <DeleteConfirmation
          handleSuccess={() => {
            // handleListMeter();
            DeleteDevice(showConfirmModal?.item?.meter_id);
          }}
          itemName={showConfirmModal?.item?.meter_name || "Meter"}
          Delete={true}
          open={showConfirmModal?.isView}
          closable={!showConfirmModal?.isView}
          onCancel={handleCancel}
        />
      ) : null}

      {replacemetermodal?.isView ? (
        <ReplaceMeter
          open={replacemetermodal?.isView}
          closable={!replacemetermodal?.isView}
          Action={replacemetermodal?.action}
          onCancel={() => {
            setShowreplacemeterModal({
              isView: false,
              action: "",
              item: "",
            });
            setDropDowns({
              ParameterType: [],
              Meter: [],
              Make: [],
              Model: [],
              Baudrate: [],
              Parity: [],
              Databits: [],
              Stopbits: [],
              isParameterTypeLoading: true,
              isMeterLoading: true,
              isMakeLoading: true,
              isModalLoading: true,
              isBaudrateLoading: true,
              isParityLoading: true,
              isDatabitsLoading: true,
              isStopbitsLoading: true,
            });
          }}
          handleSuccess={() => handleListMeter(page, size)}
          items={replacemetermodal?.item}
          DropDowns={DropDowns}
          Dropdowns={{
            getParameterTypeDropDown,
            getMeterDropDown,
            getMakeDropDown,
            getModelDropDown,
            getDataBitsDropDown,
            getParityDropDown,
            getBaudrateDropDown,
            getStopBitsDropDown,
          }}
        />
      ) : null}

      {showmodal?.isView ? (
        <Createdevicemetermodal
          open={showmodal?.isView}
          closable={!showmodal?.isView}
          Action={showmodal?.action}
          onCancel={() => {
            setShowModal({
              isView: false,
              action: "",
              item: "",
            });
            setDropDowns({
              ParameterType: [],
              Meter: [],
              Make: [],
              Model: [],
              Baudrate: [],
              Parity: [],
              Databits: [],
              Stopbits: [],
              isParameterTypeLoading: true,
              isMeterLoading: true,
              isMakeLoading: true,
              isModalLoading: true,
              isBaudrateLoading: true,
              isParityLoading: true,
              isDatabitsLoading: true,
              isStopbitsLoading: true,
            });
          }}
          handleSuccess={(type) =>
            handleListMeter(type === "create" ? 1 : page, size)
          }
          items={showmodal?.item}
          DropDowns={DropDowns}
          Dropdowns={{
            getParameterTypeDropDown,
            getMakeDropDown,
            getModelDropDown,
            getDataBitsDropDown,
            getParityDropDown,
            getBaudrateDropDown,
            getStopBitsDropDown,
          }}
        />
      ) : null}

      {resetvaluemodal?.isView ? (
        <ResetValueModal
          open={resetvaluemodal?.isView}
          closable={!resetvaluemodal?.isView}
          Action={resetvaluemodal?.action}
          onCancel={() => {
            setShowresetvalueModal({
              isView: false,
              action: "",
              item: "",
            });
          }}
          handleSuccess={() => handleListMeter(page, size)}
          items={resetvaluemodal?.item}
          DropDowns={DropDowns}
          Dropdowns={{
            getParameterTypeDropDown,
            getMeterDropDown,
          }}
        />
      ) : null}

      <Row gutter={[16, 16]}>
        <Col lg={24} xs={24}>
          <div className="primarycard h-100">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <h3 style={{ margin: "0" }} className="device_heading_style">
                Meter
              </h3>

              {CheckUserType() ? (
                <CommonButton
                  name="Create"
                  type="button"
                  onClick={() => {
                    setShowModal((pre: any) => {
                      return {
                        ...pre,
                        isView: true,
                        action: "Create",
                        item: "",
                      };
                    });
                  }}
                  // style={{ padding: "7px 10px", maxWidth: "96px", height: "32px" }}
                  classname="alert_create_btn"
                />
              ) : null}
            </div>

            <DeviceMeterTablePage
              Data={items}
              pageSize={pageSize}
              pageind={pageind}
              GetList={handleListMeter}
              setpageSize={setpageSize}
              setPageInd={setPageInd}
              setShowresetvalueModal={setShowresetvalueModal}
              setShowreplacemeterModal={setShowreplacemeterModal}
              setShowModal={setShowModal}
              setShowConfirmModal={setShowConfirmModal}
              setsubscribe={setsubscribe}
            />

            {/* <Row gutter={[16, 16]}>
          {items?.length > 0 ? (
            items?.map((ele: any) => {
              return (
                <>
                  <Col xxl={6} lg={8} md={12} xs={24}>
                    <div
                      className={`${classes.device_alert_settings_container} h-100`}
                    >
                      <div>
                        <p style={{ fontWeight: 600 }}>{ele?.meter_name}</p>

                        {CheckUserType() ? (
                          <div>
                            <Commontooltip
                              children={
                                <img
                                  src={reseticom}
                                  onClick={() => {
                                    setShowresetvalueModal((pre: any) => {
                                      return {
                                        ...pre,
                                        isView: true,
                                        action: "Reset",
                                        item: ele,
                                      };
                                    });
                                  }}
                                  style={{ width: "19px", height: "19px" }}
                                  alt="editimg"
                                />
                              }
                              msg="Reset Value"
                            />

                            <Commontooltip
                              children={
                                <img
                                  src={replaceicon}
                                  onClick={() => {
                                    setShowreplacemeterModal((pre: any) => {
                                      return {
                                        ...pre,
                                        isView: true,
                                        action: "Replace",
                                        item: ele,
                                      };
                                    });
                                  }}
                                  style={{ width: "17px", height: "17px" }}
                                  alt="editimg"
                                />
                              }
                              msg="Replace Meter"
                            />
                            <Commontooltip
                              children={
                                <img
                                  src={editimg}
                                  onClick={() => {
                                    setShowModal((pre: any) => {
                                      return {
                                        ...pre,
                                        isView: true,
                                        action: "Update",
                                        item: ele,
                                      };
                                    });
                                  }}
                                  style={{ width: "15px", height: "15px" }}
                                  alt="editimg"
                                />
                              }
                              msg="Edit"
                            />

                            <Commontooltip
                              children={
                                <img
                                  src={deleteimg}
                                  alt="deleteimg"
                                  style={{ width: "18px", height: "18px" }}
                                  onClick={() =>
                                    setShowConfirmModal({
                                      isView: true,
                                      item: ele,
                                    })
                                  }
                                />
                              }
                              msg="Delete"
                            />
                          </div>
                        ) : null}
                      </div>

                      <div style={{ padding: "12px 12px 3px" }}>
                        <div>
                          <p>
                            Meter Code :{" "}
                            <span>{getValidData(ele?.meter_code)}</span>
                          </p>
                        </div>
                        <div className="align-items-end">
                          <p>
                            Register Type :{" "}
                            <span>{getValidData(ele?.register_type)}</span>
                          </p>
                        </div>
                      </div>

                      <p
                        style={{
                          fontWeight: 600,
                          color: "#000000d6",
                          fontSize: 15,
                          padding: "0px 12px 3px",
                        }}
                      >
                        Model :{" "}
                        <span
                          style={{
                            fontWeight: 600,
                            color: "rgba(0, 0, 0, 0.5)",
                            fontSize: 15,
                          }}
                        >
                          {getValidData(ele?.model)}
                        </span>
                      </p>
                      <p
                        style={{
                          fontWeight: 600,
                          color: "#000000d6",
                          fontSize: 15,
                          padding: "0px 12px 3px",
                        }}
                      >
                        Parameter Type :{" "}
                        <span
                          style={{
                            fontWeight: 600,
                            color: "rgba(0, 0, 0, 0.5)",
                            fontSize: 15,
                          }}
                        >
                          {getValidData(ele?.parameter_type)}
                        </span>
                      </p>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          justifyContent: "space-between",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 600,
                            color: "#000000d6",
                            fontSize: 15,
                            padding: "0px 12px 0px",
                            display: "flex",
                            alignItems: "center",
                            gap: "3px",
                          }}
                        >
                          Parameter list :{" "}
                          <Commonpopover
                            children={
                              <div
                                className={
                                  classes.parameter_list_icon_container
                                }
                              >
                                <p className={classes.icon_style}>!</p>
                              </div>
                            }
                            content={getValidData(ele?.parameter_list)}
                            title="Parameter List"
                          />
                        </p>
                        <p
                          style={{
                            fontWeight: 600,
                            color: "#000000d6",
                            fontSize: 15,
                            padding: "0px 12px 3px",
                          }}
                        >
                          Total Units :{" "}
                          <span
                            style={{
                              fontWeight: 600,
                              color: "rgba(0, 0, 0, 0.5)",
                              fontSize: 15,
                            }}
                          >
                            {getValidData(ele?.wh_received)}
                          </span>
                        </p>
                      </div>

                      <p
                        style={{
                          fontWeight: 600,
                          color: "#000000d6",
                          fontSize: 15,
                          padding: "0px 12px 3px",
                        }}
                      >
                        Start Date :{" "}
                        <span
                          style={{
                            fontWeight: 600,
                            color: "rgba(0, 0, 0, 0.5)",
                            fontSize: 15,
                          }}
                        >
                          {getValidData(
                            ele?.subscription_start
                              ? MomentDateTime(ele?.subscription_start)
                              : ""
                          )}
                        </span>
                      </p>

                      <p
                        style={{
                          fontWeight: 600,
                          color: "#000000d6",
                          fontSize: 15,
                          padding: "0px 12px 3px",
                        }}
                      >
                        End Date :{" "}
                        <span
                          style={{
                            fontWeight: 600,
                            color: "rgba(0, 0, 0, 0.5)",
                            fontSize: 15,
                          }}
                        >
                          {getValidData(
                            ele?.subscription_end
                              ? MomentDateTime(ele?.subscription_end)
                              : ""
                          )}
                        </span>
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          justifyContent: "space-between",
                          padding: "0px 12px 12px",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 600,
                            color: "#000000d6",
                            fontSize: 15,
                            // padding: "0px 12px 12px",
                          }}
                        >
                          Subscription Status :{" "}
                          <span
                            style={{
                              fontWeight: 600,
                              color: "rgba(0, 0, 0, 0.5)",
                              fontSize: 15,
                            }}
                          >
                            {ele?.subscription_status_name}
                          </span>
                        </p>
                        {ele?.subscription_status === 0 ? (
                          <CommonButton
                            name="Subscribe"
                            type="button"
                            onClick={() =>
                              setsubscribe({ isView: true, item: ele })
                            }
                            classname="subscribe_btn"
                            style={{
                              padding: "4px 16px",
                              maxWidth: "93px",
                              height: "29px",
                            }}
                          />
                        ) : null}
                      </div>
                    </div>
                  </Col>
                </>
              );
            })
          ) : (
            <CommonNodataFound />
          )}
        </Row> */}

            <Commonpagination
              onShowSizeChange={Changesize} ///call when page size click
              total={total_count}
              current={page}
              onChange={(e, size) => {
                ///call when page number click
                if (size === pageSize) {
                  handleListMeter(e, size);
                }
              }}
              pageSize={size}
              style={{ position: "absolute", bottom: 0, marginBottom: "15px" }}
            />
          </div>
        </Col>

        {CheckUserType() ? (
          <Col lg={24} xs={24}>
            <DeviceUserDetails />
          </Col>
        ) : null}
      </Row>
    </>
  );
}

export default Devicemeter;
